import React from 'react';

import Gridview from '../../../elements/Gridview';
import { displayId, displayName, GridButton } from '../../../core/utils/helpers';

export default function () {
    const config = [
        { dataIndex: 'id', title: 'ID', width: 170, render: displayId },
        { dataIndex: 'first_name', title: 'Customer Name', width: 200, render: (Value, record) => displayName(record) },
        { dataIndex: 'nurse_id', title: 'Nurse ID', width: 170, render: displayId },
        { dataIndex: 'nurse_first_name', title: 'Nurse Name', render: (Value, record) => displayName(record, 'nurse_first_name', 'nurse_last_name') },
        { dataIndex: 'key', align: 'right', render: (text, record) => <GridButton href={`/customer/${record.id}`} /> },
    ];

    return (
        <Gridview
            title="Responsible for customers"
            scroll={{ y: 250 }}
            config={config}
            data={this.props.customers}
            pagination={false} />
    );
}
